/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_No_Of_UnitsInputs */

const en_admin_resource_form_no_of_units = /** @type {(inputs: Admin_Resource_Form_No_Of_UnitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. of Units`)
};

const de_admin_resource_form_no_of_units = /** @type {(inputs: Admin_Resource_Form_No_Of_UnitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten`)
};

const es_admin_resource_form_no_of_units = /** @type {(inputs: Admin_Resource_Form_No_Of_UnitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N° de unidades`)
};

const fr_admin_resource_form_no_of_units = /** @type {(inputs: Admin_Resource_Form_No_Of_UnitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nb d'unités`)
};

const nl_admin_resource_form_no_of_units = /** @type {(inputs: Admin_Resource_Form_No_Of_UnitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aantal eenheden`)
};

/** @type {(inputs: Admin_Resource_Form_No_Of_UnitsInputs) => LocalizedString} */
const it_admin_resource_form_no_of_units = en_admin_resource_form_no_of_units;

/** @type {(inputs: Admin_Resource_Form_No_Of_UnitsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_no_of_units = en_admin_resource_form_no_of_units;

/** @type {(inputs: Admin_Resource_Form_No_Of_UnitsInputs) => LocalizedString} */
const pl_admin_resource_form_no_of_units = en_admin_resource_form_no_of_units;

/** @type {(inputs: Admin_Resource_Form_No_Of_UnitsInputs) => LocalizedString} */
const hu_admin_resource_form_no_of_units = en_admin_resource_form_no_of_units;

/** @type {(inputs: Admin_Resource_Form_No_Of_UnitsInputs) => LocalizedString} */
const ro_admin_resource_form_no_of_units = en_admin_resource_form_no_of_units;

/**
* | output |
* | --- |
* | "No. of Units" |
*
* @param {Admin_Resource_Form_No_Of_UnitsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_no_of_units = /** @type {((inputs?: Admin_Resource_Form_No_Of_UnitsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_No_Of_UnitsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_no_of_units(inputs)
	if (locale === "de") return de_admin_resource_form_no_of_units(inputs)
	if (locale === "es") return es_admin_resource_form_no_of_units(inputs)
	if (locale === "fr") return fr_admin_resource_form_no_of_units(inputs)
	if (locale === "nl") return nl_admin_resource_form_no_of_units(inputs)
	if (locale === "it") return it_admin_resource_form_no_of_units(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_no_of_units(inputs)
	if (locale === "pl") return pl_admin_resource_form_no_of_units(inputs)
	if (locale === "hu") return hu_admin_resource_form_no_of_units(inputs)
	return ro_admin_resource_form_no_of_units(inputs)
});
export { admin_resource_form_no_of_units as "admin.resource_form.no_of_units" }